// place the origin Url here, since this is the default client its window location
//export const originUrl = window.location.origin;
export const originUrl = window.location.origin;
